import { Component, OnInit, ChangeDetectorRef, Input } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { MapsSidebarService } from '../../maps-sidebar.service';
import { MapsSidebarOptions } from '../../maps-sidebar-options.interface';
import { SegmentEvents } from '../../constants/SegmentEvents';

@Component({
  selector: 'app-side-bar',
  templateUrl: './side-bar.component.html',
  styleUrls: ['./side-bar.component.less']
})
export class SideBarComponent implements OnInit {

  showTrafficCount: boolean = false;
  initialLoad: boolean = true;
  closeSidebar: boolean = false;
  trafficCountSubscription: any;
  toggleMobileSidebar: any;

  getCurrentUserSubscription: any;
  enableTrafficInrixSubscription: any;
  currentUser: any;

  constructor(public ref: ChangeDetectorRef, public router: Router, public route: ActivatedRoute, public mapsSidebarService: MapsSidebarService) { }

  @Input() set options(opt: MapsSidebarOptions) {
    this.attachChanges(opt)
  }

  @Input() set toggleRandomRetailers(value: boolean) {
    this.enableRandomRetailers = value;
    if(this.enableRandomRetailers) {
      this.mapsSidebarService.randomRetailerSource.next(true)
    }
  }

 enableRandomRetailers: boolean = false;

  ngOnInit() {
    this.mapsSidebarService.checkIfMapLoaded();

    this.router.events.subscribe(event => {
      if(event instanceof NavigationEnd && this.initialLoad) {
        this.initialLoad = false;
        let queryParams = this.route.snapshot.queryParams;
        if(queryParams['sidebar']) {
          this.openSidebarSection(queryParams['sidebar']);
        }
        if(Object.keys(queryParams).length === 0) {
          this.openSidebarSection((<any>window).localStorageHandler.updateSideBarFromLS());
        }
      }
    });
  }


  ngAfterViewInit() {
    let w = (<any>window);
    this.toggleMobileSidebar = w.Events.subscribe('toggleMapsSidebar',(toggle)=>{
      this.toggleMapSidebar(!toggle);
      w.Events.publish('detectChanges');
    });

    this.trafficCountSubscription = w.Events.subscribe('toggleTrafficCountIcon',(data)=>{
      this.showTrafficCount = data.toggle;
      w.Events.publish('detectChanges');
    });

    this.getCurrentUserSubscription = w.Events.subscribe('getLoggedInUser', (data) => {
      this.currentUser = data;
      w.Events.publish('detectChanges');
    });

    this.enableTrafficInrixSubscription = w.Events.subscribe('googleMapLoaded', () => {
      if(this.route.snapshot.queryParams['sidebar'] && this.route.snapshot.queryParams['sidebar'] === 'trafficCount') {
        this.toggleTrafficCountFilter();
      }
    });
  }

  ngDoChanges() {
    if(this.enableRandomRetailers) {
      this.mapsSidebarService.randomRetailerSource.next(true)
    }
  }

  // Attach all the changes received in the options object
  attachChanges(options): void {
    Object.keys(options).forEach(a => {
      if (this.mapsSidebarService.hasOwnProperty(a)) this.mapsSidebarService[a] = options[a]
    });
  }

  openSidebarSection(toggle) {
    switch(toggle) {
      case 'retailers':
        this.toggleRetailerFilter();
        break;
      case 'places':
        this.togglePlaceFilter();
        break;
      case 'demographics':
        this.toggleDemographicFilter();
        break;
      case 'measure':
        this.toggleMeasureFilter();
        break;
      case 'properties':
        this.togglePropertyFilter();
        break;
      case 'overlays':
        this.toggleOverlayFilter();
        break;
    }
  }

  toggleRetailerFilter() {
    let w = (<any>window);
    this.mapsSidebarService.showPlaceFilter = this.mapsSidebarService.showDemographicFilter = this.mapsSidebarService.showMeasureFilter = this.mapsSidebarService.showHiddenFilter = this.mapsSidebarService.showPropertyFilter = this.mapsSidebarService.showOverlayFilter = false;
  	this.mapsSidebarService.showRetailerFilter = !this.mapsSidebarService.showRetailerFilter;
  	if(this.mapsSidebarService.showRetailerFilter) {
      (<any>window).localStorageHandler.updateSideBarToLS('retailers');
      w.Events.publish('segment', SegmentEvents.mapLayerRetailersOpen );
  		this.mapsSidebarService.retailerFilterActiveSource.next(true);
  	} else {
      (<any>window).localStorageHandler.updateSideBarToLS();
    }
    (<any>window).Events.publish('detectChanges');
  }

  togglePlaceFilter() {
    let w = (<any>window);
    this.mapsSidebarService.showRetailerFilter = this.mapsSidebarService.showDemographicFilter = this.mapsSidebarService.showMeasureFilter = this.mapsSidebarService.showHiddenFilter = this.mapsSidebarService.showPropertyFilter = this.mapsSidebarService.showOverlayFilter = false;
    this.mapsSidebarService.showPlaceFilter = !this.mapsSidebarService.showPlaceFilter;
    if(this.mapsSidebarService.showPlaceFilter) {
      (<any>window).localStorageHandler.updateSideBarToLS('places');
      w.Events.publish('segment', SegmentEvents.mapLayerPlacesOpen );
      this.mapsSidebarService.placeFilterActiveSource.next(true);
    } else {
      (<any>window).localStorageHandler.updateSideBarToLS();
    }
    (<any>window).Events.publish('detectChanges');
  }

  toggleDemographicFilter() {
    let w = (<any>window);
    this.mapsSidebarService.showPlaceFilter = this.mapsSidebarService.showRetailerFilter = this.mapsSidebarService.showMeasureFilter = this.mapsSidebarService.showHiddenFilter = this.mapsSidebarService.showPropertyFilter = this.mapsSidebarService.showOverlayFilter = false;
    this.mapsSidebarService.showDemographicFilter = !this.mapsSidebarService.showDemographicFilter;
    if(this.mapsSidebarService.showDemographicFilter) {
      (<any>window).localStorageHandler.updateSideBarToLS('demographics');
      w.Events.publish('segment', SegmentEvents.mapLayerDemographicsOpen );
      this.mapsSidebarService.demographicFilterActiveSource.next(true);
    } else {
      (<any>window).localStorageHandler.updateSideBarToLS();
    }
    (<any>window).Events.publish('detectChanges');
  }

  toggleMeasureFilter() {
    let w = (<any>window);
    this.mapsSidebarService.showPlaceFilter = this.mapsSidebarService.showRetailerFilter = this.mapsSidebarService.showDemographicFilter = this.mapsSidebarService.showHiddenFilter = this.mapsSidebarService.showPropertyFilter = this.mapsSidebarService.showOverlayFilter = false;
    this.mapsSidebarService.showMeasureFilter = !this.mapsSidebarService.showMeasureFilter;
    if(this.mapsSidebarService.showMeasureFilter) {
      (<any>window).localStorageHandler.updateSideBarToLS('measure');
      w.Events.publish('segment', SegmentEvents.mapLayerMeasureOpen );
      this.mapsSidebarService.measaureFilterActiveSource.next(true);
    } else {
      (<any>window).localStorageHandler.updateSideBarToLS();
    }
    (<any>window).Events.publish('detectChanges');
  }

  toggleHiddenFilter() {
    let w = (<any>window);
    this.mapsSidebarService.showPlaceFilter = this.mapsSidebarService.showRetailerFilter = this.mapsSidebarService.showDemographicFilter = this.mapsSidebarService.showMeasureFilter = this.mapsSidebarService.showPropertyFilter = this.mapsSidebarService.showOverlayFilter = false;
    this.mapsSidebarService.showHiddenFilter = !this.mapsSidebarService.showHiddenFilter;
    if(this.mapsSidebarService.showHiddenFilter) {
      (<any>window).hiddenItem.showAll();
      this.mapsSidebarService.hiddenFilterActiveSource.next(true);
    } else {
      (<any>window).hiddenItem.hideAll();
    }
    (<any>window).leaderLines.showLeaderLines();
    (<any>window).Events.publish('detectChanges');
  }

  togglePropertyFilter() {
    let w = (<any>window);
    this.mapsSidebarService.showPlaceFilter = this.mapsSidebarService.showRetailerFilter = this.mapsSidebarService.showDemographicFilter = this.mapsSidebarService.showMeasureFilter = this.mapsSidebarService.showHiddenFilter = this.mapsSidebarService.showOverlayFilter = false;
    this.mapsSidebarService.showPropertyFilter = !this.mapsSidebarService.showPropertyFilter;
    if(this.mapsSidebarService.showPropertyFilter) {
      (<any>window).localStorageHandler.updateSideBarToLS('properties');
      w.Events.publish('segment', SegmentEvents.mapLayerPropertiesOpen );
      this.mapsSidebarService.propertyFilterActiveSource.next(true);
    } else {
      (<any>window).localStorageHandler.updateSideBarToLS();
    }
    (<any>window).Events.publish('detectChanges');
  }

  toggleOverlayFilter() {
    let w = (<any>window);
    this.mapsSidebarService.showPlaceFilter = this.mapsSidebarService.showRetailerFilter = this.mapsSidebarService.showDemographicFilter = this.mapsSidebarService.showMeasureFilter = this.mapsSidebarService.showHiddenFilter = this.mapsSidebarService.showPropertyFilter = false;
    this.mapsSidebarService.showOverlayFilter = !this.mapsSidebarService.showOverlayFilter;
    if(this.mapsSidebarService.showOverlayFilter) {
      (<any>window).localStorageHandler.updateSideBarToLS('overlays');
      w.Events.publish('segment', SegmentEvents.mapLayerOverlaysOpen );
      this.mapsSidebarService.overlayFilterActiveSource.next(true);
    } else {
      (<any>window).localStorageHandler.updateSideBarToLS();
    }
    (<any>window).Events.publish('detectChanges');
  }

  getRetailerFilterCount() {
    let w = (<any>window),
    count = (w.mapData.showGoogleBusiness ? 1 : 0);
    if(w.apiRetailer.filteredRetailers) {
      return count + w.apiRetailer.filteredRetailers.length;
    } else {
      return count;
    }
  }

  getPlacesFilterCount() {
    if((<any>window).mapData.filteredGooglePlaces) {
      return (<any>window).mapData.filteredGooglePlaces.length;
    } else {
      return 0;
    }
  }

  getDemographicsCount() {
    if((<any>window).polygon) {
      return  ((<any>window).polygon? ((<any>window).polygon.shapes.length): 0) +
              ((<any>window).rings? ((<any>window).rings.getTotalActiveRings()): 0) +
              ((<any>window).driveTime? ((<any>window).driveTime.getTotalActiveDriveTimes()): 0);
    } else {
      return 0;
    }
  }

  isHeatMapActive() {
    let w = (<any>window);
    return (w.mapData) ? (w.mapData.showPopulation || w.mapData.showIncome || w.mapData.showAge) : false;
  }

  isDemographicsActive() {
    let w = (<any>window);
    let demographicActive = w.mapData? w.mapData.demographicFilterActive: false;
    let demoPolygon = (w.polygon && (w.polygon.shapes.length > 0)? w.mapData.showPolygons : false);
    let demorings = (w.rings && (w.rings.getTotalActiveRings() > 0)? w.mapData.showRings : false);
    let demodriveTime = (w.driveTime && (w.driveTime.getTotalActiveDriveTimes() > 0)? w.mapData.showDriveTime : false);
    return demographicActive && (demodriveTime || demoPolygon || demorings);
  }

  getMeasureCount() {
    return ((<any>window).distance.polylines)? ((<any>window).distance.polylines.length): 0;
  }

  getHiddenCount() {
    return ((<any>window).hiddenItem.markers)? ((<any>window).hiddenItem.markers.length): 0;
  }

  toggleSavedPins() {
    (<any>window).mapData.showSavedPins = !(<any>window).mapData.showSavedPins;
    (<any>window).toggleMapPins();
    this.ref.detectChanges();
  }

  isRetailerOff() {
    return (((<any>window).mapData)? !(<any>window).mapData.retailerFilterActive : false);
  }

  isHiddenOff() {
    return false;
  }

  isPlacesOff() {
    return ((<any>window).mapData)? !(<any>window).mapData.placesFilterActive : false;
  }

  isMeasureOff() {
    return ((<any>window).mapData)? !(<any>window).mapData.measureFilterActive : false;
  }

  isPropertyActive() {
    let w = (<any>window);
    return (w.mapData)?
    w.mapData.propertyFilterActive
    : false;
  }

  isOverlayActive() {
    let w = (<any>window);
    return (w.mapData)?
    w.mapData.overlayFilterActive && (w.mapData.showCounty || w.mapData.showZipcode || w.mapData.showLandParcel || this.isHeatMapActive())
    : false;
  }

  getOverlayFilterCount() {
    let w = (<any>window),
        count = 0;
    if(w.mapData) {
      w.mapData.showCounty && count++;
      w.mapData.showLandParcel && count++;
      w.mapData.showZipcode && count ++;
      this.isHeatMapActive() && count++;
    }
    return count;
  }

  cancelDom() {
    let w = (<any>window);
    w.removeClass(w.domBody, 'add-stuff');
    w.cancelAddingProperty = true;
    w.drawingManager.setDrawingMode(null);
  }

  toggleMapSidebar(toggle?) {
    let w = (<any>window);
    w.Events.publish('toggleMapSibebarClicked');
    if(toggle !== undefined) {
      this.closeSidebar = toggle;
      w.Events.publish('detectChanges');
    } else {
      this.closeSidebar = !this.closeSidebar;
      w.Events.publish('detectChanges');
    }
  }

  toggleTrafficCountFilter() {
    let w = (<any>window);
    this.mapsSidebarService.showPlaceFilter = this.mapsSidebarService.showRetailerFilter = 
    this.mapsSidebarService.showDemographicFilter = this.mapsSidebarService.showMeasureFilter = 
    this.mapsSidebarService.showHiddenFilter = this.mapsSidebarService.showPropertyFilter = 
    this.mapsSidebarService.showOverlayFilter = false;
    (<any>window).localStorageHandler.updateSideBarToLS(this.showTrafficCount ? 'trafficCount' : '');
    w.toggleTraffic(!w.mapData.showTrafficCount);
    w.Events.publish('segment', SegmentEvents.mapLayerTrafficClick);
    w.Events.publish('detectChanges');
  }

  isInrixDisabled() {
    return (<any>window).apiTrafficInrix.disabledInrix;
  }

  ngOnDestroy() {
    this.closeSidebar = false;
    this.toggleMobileSidebar.unsubscribe();
    this.getCurrentUserSubscription && this.getCurrentUserSubscription.unsubscribe();
  }

  showDemographicLayer() {
    let w = (<any>window);
    return  w.userData && w.userData.organizationType && w.userData.organizationType !== 'FREE';
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/maps-sidebar/components/side-bar/side-bar.component.ts